import MobileDeviceGrid from './mobile-device-grid';
import { useParams } from 'react-router-dom';
import { useUserSettings } from '../../../../utils/use-user-settings';

export default function MobileDevicePage() {
  const { userEmail } = useParams() as { userEmail: string };
  const { userRoles, changeLogRoles, toolsRoles } = useUserSettings();
  return (
    <MobileDeviceGrid
      userEmail={userEmail}
      userRoles={userRoles}
      toolsRoles={toolsRoles}
      changeLogRoles={changeLogRoles}
    />
  );
}
